import PrivacyComponent from "../components/privacycomponents/privacycomponent"

const PrivacyPage = () => {

    return(
        <PrivacyComponent/>
    )
}

export default PrivacyPage